<template>
    <div id="checkout-frame" class="bg-white" :class="{ busy: isBusy || showReview }">
        <header id="checkout-header">
            <a class="hidden-xs-down" :href="`${$scope.URL_STORE_PREFIX}/sacola`">
                <span>
                    <i class="icon-cr icon-chevron-left"></i>
                    <span class="text-uppercase text-yanone">{{
                        $t('_checkout.backToPurchase')
                    }}</span>
                </span>
            </a>

            <a
                id="checkout-logo"
                :class="$scope.TENANT_IDENTIFIER === 'chicorei' ? 'logo-cr-text' : 'logo-up-text'"
                :href="`${$scope.URL_STORE_PREFIX}/sacola`"
            ></a>

            <div class="text-right">
                <img
                    id="trustwaveSealImage"
                    alt="This site is protected by Trustwave's Trusted Commerce program"
                    border="0"
                    onclick="javascript:window.open('https://sealserver.trustwave.com/cert.php?customerId=1ced6b7a51604ac4a62bbbde702d794f&amp;size=105x54&amp;style=', 'c_TW', 'location=no, toolbar=no, resizable=yes, scrollbars=yes, directories=no, status=no, width=615, height=720'); return false;"
                    oncontextmenu="javascript:alert('Copying Prohibited by Law - Trusted Commerce is a Service Mark of TrustWave Holdings, Inc.'); return false;"
                    src="https://sealserver.trustwave.com/seal_image.php?customerId=1ced6b7a51604ac4a62bbbde702d794f&amp;size=105x54&amp;style="
                    style="cursor: pointer"
                    title="This site is protected by Trustwave's Trusted Commerce program"
                />
            </div>
        </header>

        <hr />

        <Spinner v-if="isBusy && !cart" />

        <template v-else-if="cart">
            <div id="checkout-main">
                <slot />
            </div>
            <footer>
                <hr />
                <p class="text-small text-center my-0 pb">
                    <span v-if="$scope.TENANT_IDENTIFIER === 'chicorei'"
                        >A loja online Chicorei.com é operada pelo CNPJ:
                        09.148.763/0001-59.&nbsp;</span
                    >
                    <span v-else>Operada pelo CNPJ: 09.148.763/0001-59.&nbsp;</span>
                    <span v-if="$scope.IS_WHOLESALER">
                        Atendimento a Lojistas: E-mail:
                        <a href="mailto:contato@chicorei.com.br">contato@chicorei.com.br</a>
                        | Atendimento de 8h às 17h
                    </span>
                    <span v-else>
                        Caixa Postal 45045 Juiz de Fora - MG CEP: 36010 - 972 / Atendimento: Segunda
                        a Sexta 08:00 às 18:00&nbsp;-
                    </span>
                    <a class="text-underline" @click="triggerOnlineChat">
                        {{ $t('contactUs') }}
                    </a>
                </p>
            </footer>
        </template>

        <div v-else class="alert-danger">
            {{ $t('_checkout.errorLoadItems') }}
        </div>
    </div>
</template>

<script>
    import store from '../../script/store/checkout';
    import Spinner from '../../components/feedback/spinner/Spinner.vue';
    import { reamazeClickHandler } from '../../script/common';

    export default {
        name: 'CheckoutCard',

        components: {
            Spinner,
        },

        props: {
            showReview: Boolean,
        },

        data() {
            return {
                storeState: store.state,
            };
        },

        computed: {
            cart() {
                return this.storeState.cart.cart;
            },

            isBusy() {
                return store.isBusy();
            },
        },

        methods: {
            triggerOnlineChat() {
                reamazeClickHandler();
            },
        },
    };
</script>
